export enum FeatureToggles {
  ENABLE_LIVECHAT_APPLICATION_MONITORING_FREEZE = 'enable_livechat_application_monitoring_freeze',
  LIVECHAT_KANBAN_ENABLE_PERSIST_FILTER = 'livechat_kanban_enable_persist_filter',
  ENABLE_FLOW = 'enable_flow',
  CLEAR_ATTENDANCE_SELECTED_ID = 'clear_attendance_selected_id',
  ENABLE_PLATFORM_TIMESTAMP_ORDERING = 'enable_platform_timestamp_ordering',
  ENABLED_FREE_ENTRY_POINT = 'enabled_free_entry_point',
  ENABLE_SOFTPHONE_RINGTONE_VOLUME_SLIDER = 'enable_softphone_ringtone_volume_slider',
  ENABLED_LIVECHAT_SHOW_MESSAGE_COST = 'enabled_livechat_show_message_cost',
  LIVECHAT_IOS_MP3_AUDIO_RECORDER = 'livechat_ios_mp3_audio_recorder',
  LIVECHAT_ENABLE_CREDITS_REPORT_MODAL = 'livechat_enable_credits_report_modal',
  ENABLE_WHATSAPP_CREDITS_V2 = 'enable_whatsapp_credits_v2',
  LIVECHAT_ATTACHMENT_IN_MEMORY_UPLOAD = 'livechat_attachment_in_memory_upload',
  ENABLED_GET_AGENT_ACTIVATION_LOG_LIVECHAT = 'enabled_get_agent_activation_log_livechat',
  ENABLE_GUPSHUP_BSUID_SEND_V1 = 'enable_gupshup_bsuid_send_v1',
  WPP_GOD_BSUID_START_CONVERSATION = 'wpp_god_bsuid_start_conversation',
  ENABLE_USER_INACTIVITY_DETECTION = 'enable_user_inactivity_detection',
  ENABLE_REQUEST_CONTACT_INFO = 'enable_request_contact_info',
}
